"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _enviro = _interopRequireDefault(require("enviro"));

// Do not remove this.
// Marketing Ops relies on this convert.com analytics
// container to be loaded on all links that are owned by 53
var HUBSPOT_INTERNAL_PORTAL = 53;

function _default(portalId) {
  var key = 'convert_analytics';

  if (portalId === HUBSPOT_INTERNAL_PORTAL && _enviro.default.deployed(key) && _enviro.default.getInternal(key) === 'prod') {
    var firstScript = document.getElementsByTagName('script')[0];
    var tag = document.createElement('script');
    tag.id = 'hubspot-convert-container';
    tag.async = true;
    tag.src = '//cdn-3.convertexperiments.com/js/10031559-1003891.js';
    firstScript.parentNode.insertBefore(tag, firstScript);
  }
}

module.exports = exports.default;